/* Jalecos Mania — PDP (Parte 1): galeria com scroll/setas/indicadores, stories em
   modal fullscreen, lightbox com zoom/pan/pinch e seleção de tamanho + add-to-cart
   integrado ao cart drawer (mesmo evento nativo que faz o drawer abrir). */
(function () {
  var root = document.querySelector('[data-jm-pdp]');
  if (!root) return;

  /* ============ Galeria (scroll horizontal + setas + indicadores) ============ */
  (function () {
    var track = root.querySelector('[data-jm-gallery]');
    if (!track) return;
    var figures = Array.prototype.slice.call(track.querySelectorAll('figure'));
    var dotsWrap = root.querySelector('[data-jm-dots]');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('i')) : [];
    var prev = root.querySelector('[data-jm-gallery-prev]');
    var next = root.querySelector('[data-jm-gallery-next]');
    var current = 0;

    function setActive(index) {
      current = Math.max(0, Math.min(figures.length - 1, index));
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
      if (dotsWrap) dotsWrap.setAttribute('aria-label', 'Foto ' + (current + 1) + ' de ' + figures.length);
    }

    function goTo(index) {
      var i = Math.max(0, Math.min(figures.length - 1, index));
      // cada foto ocupa 100% da largura do track (gap 0), então a posição de rolagem
      // da foto i é exatamente i * largura. Atribuir scrollLeft direto funciona em
      // todo navegador; a animação vem do scroll-behavior: smooth no CSS.
      track.scrollLeft = i * track.clientWidth;
      setActive(i);
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    track.addEventListener('scroll', function () {
      if (!figures.length) return;
      var w = figures[0].getBoundingClientRect().width;
      if (w <= 0) return;
      setActive(Math.round(track.scrollLeft / w));
    }, { passive: true });
  })();

  /* ============ Stories (modal fullscreen, com vídeo real) ============ */
  (function () {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-jm-story]'));
    var modal = root.querySelector('[data-jm-story-modal]');
    if (!buttons.length || !modal) return;

    var image = modal.querySelector('[data-jm-story-img]');
    var video = modal.querySelector('[data-jm-story-video]');
    var muteBtn = modal.querySelector('[data-jm-story-mute]');
    var somOn = modal.querySelector('[data-jm-som-on]');
    var somOff = modal.querySelector('[data-jm-som-off]');
    var stage = modal.querySelector('[data-jm-story-stage]');
    var title = modal.querySelector('[data-jm-story-title]');
    var subtitle = modal.querySelector('[data-jm-story-sub]');
    var progress = Array.prototype.slice.call(modal.querySelectorAll('[data-jm-story-progress] i'));
    var index = 0;
    var timer;
    var DURATION = parseInt(modal.dataset.duration, 10) || 5000;
    var mudo = false; // o clique na bolha é gesto do usuário: som liberado

    modal.style.setProperty('--jm-story-dur', DURATION / 1000 + 's');

    function atualizaMute() {
      if (!muteBtn) return;
      if (somOn) somOn.hidden = mudo;
      if (somOff) somOff.hidden = !mudo;
    }

    function pararVideo() {
      if (!video) return;
      video.pause();
      video.ontimeupdate = null;
      video.onended = null;
      video.onloadedmetadata = null;
    }

    function render(i) {
      index = (i + buttons.length) % buttons.length;
      var btn = buttons[index];
      var temVideo = !!(btn.dataset.video && video);
      buttons.forEach(function (b, p) { b.classList.toggle('is-active', p === index); });
      if (title) title.textContent = btn.dataset.title || 'Vídeo do produto';
      if (subtitle) subtitle.textContent = btn.dataset.subtitle || '';

      modal.classList.toggle('is-video', temVideo);
      if (muteBtn) muteBtn.hidden = !temVideo;
      clearTimeout(timer);
      pararVideo();

      progress.forEach(function (bar, p) {
        bar.classList.toggle('is-active', p === index);
        bar.classList.toggle('is-done', p < index);
        bar.classList.toggle('is-anim', p === index && !temVideo);
        bar.style.removeProperty('--jm-sp');
        bar.style.animation = 'none';
        void bar.offsetHeight; // reflow para reiniciar a animação
        bar.style.animation = '';
      });

      if (temVideo) {
        if (image) image.hidden = true;
        video.hidden = false;
        video.muted = mudo;
        atualizaMute();
        if (video.dataset.src !== btn.dataset.video) {
          video.dataset.src = btn.dataset.video;
          video.src = btn.dataset.video;
        } else {
          video.currentTime = 0;
        }
        video.poster = btn.dataset.poster || '';
        var barra = progress[index];
        video.ontimeupdate = function () {
          if (barra && video.duration) barra.style.setProperty('--jm-sp', (video.currentTime / video.duration * 100).toFixed(2) + '%');
        };
        video.onended = function () { render(index + 1); };
        var p = video.play();
        if (p && p.catch) {
          p.catch(function () {
            // autoplay com som bloqueado: cai pro mudo e sinaliza no botão
            mudo = true;
            video.muted = true;
            atualizaMute();
            video.play().catch(function () {});
          });
        }
      } else {
        if (video) video.hidden = true;
        if (image) {
          image.hidden = false;
          image.src = btn.dataset.poster || '';
          image.alt = btn.dataset.title || 'Vídeo do produto';
        }
        if (modal.classList.contains('is-open')) timer = setTimeout(function () { render(index + 1); }, DURATION);
      }
    }

    function open(i) {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('jm-story-lock');
      render(i);
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('jm-story-lock');
      clearTimeout(timer);
      pararVideo();
    }

    buttons.forEach(function (btn, i) { btn.addEventListener('click', function () { open(i); }); });
    modal.querySelectorAll('[data-jm-story-close]').forEach(function (el) { el.addEventListener('click', close); });
    var prev = modal.querySelector('[data-jm-story-prev]');
    var next = modal.querySelector('[data-jm-story-next]');
    if (prev) prev.addEventListener('click', function () { render(index - 1); });
    if (next) next.addEventListener('click', function () { render(index + 1); });

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        mudo = !mudo;
        if (video) video.muted = mudo;
        atualizaMute();
      });
    }

    // zonas de toque no "celular": terço esquerdo volta, terço direito avança,
    // centro pausa/retoma o vídeo (igual aos stories de verdade)
    if (stage) {
      stage.addEventListener('click', function (e) {
        if (e.target.closest('[data-jm-story-mute]')) return;
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        if (x < 0.33) render(index - 1);
        else if (x > 0.67) render(index + 1);
        else if (video && !video.hidden) { video.paused ? video.play() : video.pause(); }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') render(index - 1);
      else if (e.key === 'ArrowRight') render(index + 1);
      else if (e.key === ' ') { e.preventDefault(); if (video && !video.hidden) { video.paused ? video.play() : video.pause(); } }
    });
  })();

  /* ============ Lightbox com zoom/pan/pinch ============ */
  (function () {
    var imgs = Array.prototype.slice.call(root.querySelectorAll('[data-jm-gallery] figure img'));
    if (!imgs.length) return;
    var sources = imgs.map(function (im) { return { src: im.getAttribute('src'), alt: im.getAttribute('alt') || '' }; });

    var lb = document.createElement('div');
    lb.className = 'jm-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML =
      '<div class="jm-lb__backdrop"></div>' +
      '<div class="jm-lb__stage"><img class="jm-lb__img" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==" alt=""></div>' +
      '<button class="jm-lb__close" aria-label="Fechar">×</button>' +
      '<button class="jm-lb__prev" aria-label="Imagem anterior"><svg viewBox="0 0 24 24"><path d="m15 5-7 7 7 7"/></svg></button>' +
      '<button class="jm-lb__next" aria-label="Próxima imagem"><svg viewBox="0 0 24 24"><path d="m9 5 7 7-7 7"/></svg></button>' +
      '<button class="jm-lb__zoom" aria-label="Ampliar"><svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="M11 8v6M8 11h6M20 20l-3.4-3.4"/></svg></button>' +
      '<div class="jm-lb__counter"></div>';
    document.body.appendChild(lb);

    var stage = lb.querySelector('.jm-lb__stage');
    var img = lb.querySelector('.jm-lb__img');
    var counter = lb.querySelector('.jm-lb__counter');
    var MAXZOOM = 4;
    var index = 0, zoom = 1, panX = 0, panY = 0, moved = false, lastTap = 0, tapTimer = null;
    function clearTap() { if (tapTimer) { clearTimeout(tapTimer); tapTimer = null; } }
    var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
    var dist = function (a, b) { return Math.hypot(a.x - b.x, a.y - b.y); };

    function apply(animate) {
      img.style.transition = animate ? 'transform .2s ease' : 'none';
      img.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + zoom + ')';
      var z = zoom > 1.01;
      img.classList.toggle('is-zoomed', z);
      lb.classList.toggle('is-zoomed', z);
    }
    function clampPan() {
      var maxX = Math.max(0, (img.offsetWidth * zoom - stage.clientWidth) / 2);
      var maxY = Math.max(0, (img.offsetHeight * zoom - stage.clientHeight) / 2);
      panX = clamp(panX, -maxX, maxX);
      panY = clamp(panY, -maxY, maxY);
    }
    function reset(animate) { zoom = 1; panX = 0; panY = 0; apply(animate); }
    function zoomToPoint(cx, cy, target, animate) {
      var r = stage.getBoundingClientRect();
      var sx = cx - r.left - r.width / 2;
      var sy = cy - r.top - r.height / 2;
      var z0 = zoom, z1 = clamp(target, 1, MAXZOOM);
      panX = sx - (z1 / z0) * (sx - panX);
      panY = sy - (z1 / z0) * (sy - panY);
      zoom = z1;
      clampPan();
      apply(animate);
    }
    function show(i) {
      index = (i + sources.length) % sources.length;
      img.src = sources[index].src;
      img.alt = sources[index].alt;
      counter.textContent = (index + 1) + ' / ' + sources.length;
      reset(false);
    }
    function open(i) {
      clearTap();
      show(i);
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.classList.add('jm-lb-lock');
    }
    function close() {
      clearTap();
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('jm-lb-lock');
      reset(false);
    }

    imgs.forEach(function (im, i) { im.addEventListener('click', function () { open(i); }); });
    lb.querySelector('.jm-lb__close').addEventListener('click', close);
    lb.querySelector('.jm-lb__prev').addEventListener('click', function (e) { e.stopPropagation(); show(index - 1); });
    lb.querySelector('.jm-lb__next').addEventListener('click', function (e) { e.stopPropagation(); show(index + 1); });
    lb.querySelector('.jm-lb__zoom').addEventListener('click', function (e) {
      e.stopPropagation();
      if (zoom > 1.01) reset(true);
      else zoomToPoint(window.innerWidth / 2, window.innerHeight / 2, 2.5, true);
    });
    if (sources.length < 2) {
      lb.querySelector('.jm-lb__prev').style.display = 'none';
      lb.querySelector('.jm-lb__next').style.display = 'none';
    }

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(index - 1);
      else if (e.key === 'ArrowRight') show(index + 1);
    });

    stage.addEventListener('click', function (e) {
      if (moved || e.target === img) return;
      if (zoom <= 1.01) close();
    });
    stage.addEventListener('dblclick', function (e) {
      if (zoom > 1.01) reset(true);
      else zoomToPoint(e.clientX, e.clientY, 2.5, true);
    });
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoomToPoint(e.clientX, e.clientY, zoom * (e.deltaY < 0 ? 1.2 : 0.82), false);
    }, { passive: false });

    var pointers = new Map();
    var drag = null, swipe = null, pinch = null;
    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.jm-lb__close,.jm-lb__prev,.jm-lb__next,.jm-lb__zoom')) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      stage.setPointerCapture(e.pointerId);
      moved = false;
      if (pointers.size === 2) {
        var p = Array.from(pointers.values());
        var r = stage.getBoundingClientRect();
        pinch = { d0: dist(p[0], p[1]), z0: zoom, panX0: panX, panY0: panY,
          mx: (p[0].x + p[1].x) / 2 - r.left - r.width / 2,
          my: (p[0].y + p[1].y) / 2 - r.top - r.height / 2 };
        drag = null; swipe = null;
      } else if (zoom > 1.01) {
        drag = { x: e.clientX, y: e.clientY, panX: panX, panY: panY };
        img.classList.add('is-grabbing');
      } else {
        swipe = { x: e.clientX, y: e.clientY };
      }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pinch && pointers.size >= 2) {
        var p = Array.from(pointers.values());
        var z1 = clamp(pinch.z0 * dist(p[0], p[1]) / pinch.d0, 1, MAXZOOM);
        panX = pinch.mx - (z1 / pinch.z0) * (pinch.mx - pinch.panX0);
        panY = pinch.my - (z1 / pinch.z0) * (pinch.my - pinch.panY0);
        zoom = z1; clampPan(); apply(false); moved = true;
      } else if (drag) {
        panX = drag.panX + (e.clientX - drag.x);
        panY = drag.panY + (e.clientY - drag.y);
        clampPan(); apply(false);
        if (Math.abs(e.clientX - drag.x) + Math.abs(e.clientY - drag.y) > 6) moved = true;
      } else if (swipe) {
        if (Math.abs(e.clientX - swipe.x) > 8) moved = true;
      }
    });
    function endPointer(e) {
      pointers.delete(e.pointerId);
      img.classList.remove('is-grabbing');
      if (swipe && zoom <= 1.01 && !pinch) {
        var dx = e.clientX - swipe.x;
        if (Math.abs(dx) > 55) show(index + (dx < 0 ? 1 : -1));
        else if (!moved && e.pointerType !== 'mouse') {
          var now = performance.now();
          if (now - lastTap < 300) {
            // duplo-toque = zoom; cancela o fechamento pendente do 1º toque
            clearTap();
            zoomToPoint(e.clientX, e.clientY, 2.5, true);
            lastTap = 0;
          } else {
            // toque simples na foto (não ampliada) fecha; espera 300ms p/ descartar duplo-toque
            lastTap = now;
            clearTap();
            tapTimer = setTimeout(function () { tapTimer = null; if (zoom <= 1.01) close(); }, 300);
          }
        }
      }
      if (zoom <= 1.01) reset(false);
      drag = null; swipe = null;
      if (pointers.size < 2) pinch = null;
    }
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);
  })();

  /* ============ Tamanho + add-to-cart (principal + barra mobile) ============ */
  (function () {
    var addBtn = root.querySelector('[data-jm-pdp-add]');
    var addBtnMobile = root.querySelector('[data-jm-pdp-add-mobile]');
    if (!addBtn && !addBtnMobile) return;
    var msg = root.querySelector('[data-jm-pdp-msg]');
    var sizeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-jm-size]'));
    var viesButtons = Array.prototype.slice.call(root.querySelectorAll('[data-jm-vies-btn]'));
    var viesLabel = root.querySelector('[data-jm-vies-label]');
    var hasSize = sizeButtons.length > 0;
    var hasVies = viesButtons.length > 0;
    var hasOptions = hasSize || hasVies;
    var busy = false;

    var variants = [];
    try {
      var raw = root.querySelector('[data-jm-pdp-variants]');
      if (raw) variants = JSON.parse(raw.textContent);
    } catch (e) { variants = []; }

    var selectedSize = null;
    var selectedColor = null;

    function showMsg(text, isError) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.classList.toggle('is-error', !!isError);
    }

    // tamanho + cor do viés resolvem exatamente uma variante
    function currentVariantId() {
      if (!hasOptions) return (addBtn || addBtnMobile).getAttribute('data-default-variant');
      if (hasSize && !selectedSize) return null;
      if (hasVies && !selectedColor) return null;
      var matches = variants.filter(function (v) {
        return (!hasSize || v.option1 === selectedSize) && (!hasVies || v.option2 === selectedColor);
      });
      var chosen = matches.filter(function (v) { return v.available; })[0] || matches[0];
      return chosen ? String(chosen.id) : null;
    }

    // disponibilidade cruzada: um tamanho fica ativo se há variante disponível com ele
    // (respeitando a cor já escolhida), e vice-versa. Seleção que ficou impossível é limpa.
    function refreshAvailability() {
      if (hasSize) sizeButtons.forEach(function (btn) {
        var val = btn.getAttribute('data-value');
        var ok = variants.some(function (v) {
          return v.option1 === val && v.available && (!hasVies || !selectedColor || v.option2 === selectedColor);
        });
        btn.disabled = !ok;
        if (!ok && btn.classList.contains('is-selected')) { btn.classList.remove('is-selected'); selectedSize = null; }
      });
      if (hasVies) viesButtons.forEach(function (btn) {
        var val = btn.getAttribute('data-value');
        var ok = variants.some(function (v) {
          return v.option2 === val && v.available && (!hasSize || !selectedSize || v.option1 === selectedSize);
        });
        btn.disabled = !ok;
        if (!ok && btn.classList.contains('is-selected')) {
          btn.classList.remove('is-selected'); btn.setAttribute('aria-checked', 'false');
          selectedColor = null; if (viesLabel) viesLabel.textContent = '';
        }
      });
    }

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        sizeButtons.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selectedSize = btn.getAttribute('data-value');
        showMsg('');
        refreshAvailability();
      });
    });

    viesButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        viesButtons.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-selected'); btn.setAttribute('aria-checked', 'true');
        selectedColor = btn.getAttribute('data-value');
        if (viesLabel) viesLabel.textContent = ': ' + selectedColor;
        showMsg('');
        refreshAvailability();
      });
    });

    refreshAvailability();

    function trigger() {
      if (busy) return;
      if (hasVies && !selectedColor) {
        showMsg('Selecione a cor do viés para continuar.', true);
        var vwrap = root.querySelector('[data-jm-vies-wrap]');
        if (vwrap) vwrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (hasSize && !selectedSize) {
        showMsg('Selecione um tamanho para continuar.', true);
        var sizes = root.querySelector('[data-jm-sizes]');
        if (sizes) sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var variantId = currentVariantId();
      if (!variantId) { showMsg('Essa combinação está indisponível.', true); return; }
      addToCart(variantId);
    }

    if (addBtn) addBtn.addEventListener('click', function () { if (!addBtn.disabled) trigger(); });
    if (addBtnMobile) addBtnMobile.addEventListener('click', function () { if (!addBtnMobile.disabled) trigger(); });

    async function addToCart(variantId) {
      busy = true;
      var label = addBtn ? addBtn.textContent : '';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adicionando...'; }
      if (addBtnMobile) addBtnMobile.disabled = true;
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: 'cart-drawer-section',
            sections_url: '/',
          }),
        });
        if (!res.ok) throw new Error('add-failed');
        var added = await res.json();

        var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });

        try {
          var mod = await import('@shopify/events');
          var CartLinesUpdateEvent = mod.CartLinesUpdateEvent;
          var deferred = CartLinesUpdateEvent.createPromise();
          document.dispatchEvent(new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(variantId), quantity: 1 }],
            promise: deferred.promise,
          }));
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { items: cart.items, source: 'jm-produto', itemCount: 1, didError: false, sections: added.sections },
          });
        } catch (e) { /* segue só com contador */ }

        if (addBtn) addBtn.textContent = 'Adicionado ✓';
        showMsg('');
        window.setTimeout(function () {
          if (addBtn) { addBtn.textContent = label; addBtn.disabled = false; }
          if (addBtnMobile) addBtnMobile.disabled = false;
          busy = false;
        }, 1600);
      } catch (err) {
        if (addBtn) { addBtn.textContent = label; addBtn.disabled = false; }
        if (addBtnMobile) addBtnMobile.disabled = false;
        busy = false;
        showMsg('Não foi possível adicionar. Tente novamente.', true);
      }
    }
  })();

  /* ============ Favoritos (wishlist local) ============ */
  (function () {
    var heart = root.querySelector('[data-jm-heart]');
    if (!heart) return;
    var handle = heart.getAttribute('data-product-handle');
    function sync() {
      var on = window.JMWishlist ? window.JMWishlist.has(handle) : false;
      heart.classList.toggle('is-active', on);
      heart.setAttribute('aria-pressed', String(on));
    }
    sync();
    heart.addEventListener('click', function () {
      if (window.JMWishlist) window.JMWishlist.toggle(handle);
    });
    document.addEventListener('jm:wishlist:change', sync);
  })();

  /* ============ Tabela de medidas: abre o accordion e rola até ele ============ */
  (function () {
    var openBtn = root.querySelector('[data-jm-size-guide]');
    var details = root.querySelector('[data-jm-size-details]');
    if (!openBtn || !details) return;
    openBtn.addEventListener('click', function () {
      details.open = true;
      details.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  })();

  /* ============ Consulta de frete (CEP) — cotação real ============ */
  /* Mesmo endpoint do checkout (remetente, dias de preparação e acréscimo já
     aplicados no servidor) — um só número em todo lugar. A cotação dispara
     sozinha quando o CEP fica completo (debounce), sem precisar do botão.
     Falhou/não configurado → mantém a mensagem estimada padrão. */
  function jmQuoteFrete(cep, itemCount, declaredCents, weightGrams, done) {
    var base = window.JM_FRETE_ENDPOINT || 'https://checkout.jalecosmania.com.br';
    fetch(base + '/api/shipping/quote', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cep: cep, itemCount: itemCount || 1, declaredCents: declaredCents || 0, weightGrams: weightGrams || 0 })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { done(data && data.configured && data.quotes && data.quotes.length ? data.quotes : null); })
      .catch(function () { done(null); });
  }
  function jmRenderQuotes(out, quotes) {
    out.textContent = '';
    quotes.forEach(function (q) {
      var line = document.createElement('div');
      var name = document.createElement('span');
      name.textContent = (q.name || (q.carrierLabel + ' ' + q.label)) + ' — ';
      var price = document.createElement('b');
      price.textContent = 'R$ ' + (q.priceCents / 100).toFixed(2).replace('.', ',');
      var term = document.createElement('span');
      term.textContent = ' · ' + q.durationLabel;
      line.appendChild(name); line.appendChild(price); line.appendChild(term);
      out.appendChild(line);
    });
  }
  (function () {
    var form = root.querySelector('[data-jm-pdp-shipping]');
    if (!form) return;
    var input = form.querySelector('input');
    var out = form.querySelector('[data-jm-pdp-shipping-msg]');
    if (!input || !out) return;
    var timer = null;
    var ticket = 0;
    var lastCep = '';
    function run(cep) {
      var mine = ++ticket;
      lastCep = cep;
      out.textContent = 'Calculando frete…';
      var qtyInput = root.querySelector('[data-jm-qty-input], input[name="quantity"]');
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value || '1', 10) || 1);
      var grams = Math.max(0, parseInt(form.dataset.grams || '0', 10) || 0) * qty;
      var priceCents = Math.max(0, parseInt(form.dataset.priceCents || '0', 10) || 0) * qty;
      jmQuoteFrete(cep, qty, priceCents, grams, function (quotes) {
        if (mine !== ticket) return; // resposta velha: ignora
        if (quotes) jmRenderQuotes(out, quotes);
        else out.textContent = 'Entrega estimada em 4 a 7 dias úteis · Frete grátis acima da meta.';
      });
    }
    input.addEventListener('input', function () {
      var cep = (input.value || '').replace(/\D/g, '');
      if (timer) clearTimeout(timer);
      if (cep.length !== 8 || cep === lastCep) return;
      timer = setTimeout(function () { run(cep); }, 350);
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var cep = (input.value || '').replace(/\D/g, '');
      if (cep.length < 8) { out.textContent = 'Digite um CEP válido.'; return; }
      run(cep);
    });
  })();
})();
